import React, { useState } from "react";
import { servDropdown } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";

function ServDropdown() {
  const [servdropdown, setServDropdown] = useState(false);

  return (
    <>
      <ul
        className={servdropdown ? "serv-submenu clicked" : "serv-submenu"}
        onClick={() => setServDropdown(!servdropdown)} > {
          servDropdown.map((item) => {
            return (
              <li key={item.id}>
                <Link to={item.path} className={item.cName} onClick={() => setServDropdown(false)}>
                  {item.title}
                </Link>
              </li>
            );
          })
        } </ul>
    </>
  );
}

export default ServDropdown;
